'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _adverseEvents = require('services/adverse-events.service');

var _adverseEvents2 = _interopRequireDefault(_adverseEvents);

var _alert = require('services/alert.service');

var _alert2 = _interopRequireDefault(_alert);

var _animalType = require('services/animal-type.service');

var _animalType2 = _interopRequireDefault(_animalType);

var _array = require('services/array.service');

var _array2 = _interopRequireDefault(_array);

var _auth = require('services/auth.service');

var _auth2 = _interopRequireDefault(_auth);

var _category = require('services/category.service');

var _category2 = _interopRequireDefault(_category);

var _company = require('services/company.service');

var _company2 = _interopRequireDefault(_company);

var _ingredient = require('services/ingredient.service');

var _ingredient2 = _interopRequireDefault(_ingredient);

var _feedback = require('services//feedback.service');

var _feedback2 = _interopRequireDefault(_feedback);

var _loading = require('services/loading.service');

var _loading2 = _interopRequireDefault(_loading);

var _people = require('services/people.service');

var _people2 = _interopRequireDefault(_people);

var _product = require('services/product.service');

var _product2 = _interopRequireDefault(_product);

var _regulator = require('services/regulator.service');

var _regulator2 = _interopRequireDefault(_regulator);

var _report = require('services/report.service');

var _report2 = _interopRequireDefault(_report);

var _session = require('services/session.service');

var _session2 = _interopRequireDefault(_session);

var _toast = require('services/toast.service');

var _toast2 = _interopRequireDefault(_toast);

var _usageData = require('services/usage-data.service');

var _usageData2 = _interopRequireDefault(_usageData);

var _directives = require('./directives/directives.module');

var _directives2 = _interopRequireDefault(_directives);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('common', [_directives2.default]).service('AdverseEventsService', _adverseEvents2.default).service('AnimalTypeService', _animalType2.default).service('AlertService', _alert2.default).service('ArrayService', _array2.default).service('AuthService', _auth2.default).service('CategoryService', _category2.default).service('CompanyService', _company2.default).service('FeedbackService', _feedback2.default).service('IngredientService', _ingredient2.default).service('LoadingService', _loading2.default).service('PeopleService', _people2.default).service('ProductService', _product2.default).service('RegulatorService', _regulator2.default).service('ReportService', _report2.default).service('SessionService', _session2.default).service('ToastService', _toast2.default).service('UsageDataService', _usageData2.default).name;


// WEBPACK FOOTER //
// ./common/common.module.js